import { usePage } from "@inertiajs/vue3";
import { App } from "vue";
import type { RouteKeys, RouteParams } from "@/routes";
import reverseUrl from "@/routes";

export type Language = "en" | "nl" | "pl" | "tr" | "index";

const routes = import.meta.glob("../routes/*.ts", {
    eager: true,
    import: "default",
});

const reverseLang = <T extends RouteKeys>(
    urlName: T,
    lang: Language,
    ...args: Record<string, never> extends RouteParams<T>
        ? [args?: never]
        : [args: RouteParams<T>]
) => {
    const reverse = routes[`../routes/${lang}.ts`] as typeof reverseUrl;
    return reverse(urlName, ...args);
};

const reverse: typeof reverseUrl = <T extends RouteKeys>(
    urlName: T,
    ...args: Record<string, never> extends RouteParams<T>
        ? [args?: never]
        : [args: RouteParams<T>]
) => {
    const lang = (usePage().props?.language as Language) || "index";
    return reverseLang(urlName, lang, ...args);
};

const routeReverse = {
    install: (app: App) => {
        app.config.globalProperties.$reverseLang = reverseLang;
        app.config.globalProperties.$reverse = reverse;
    },
};

export { reverse, reverseLang };
export default routeReverse;
